import { Close } from "@mui/icons-material";
import {
  Alert,
  AlertColor,
  Button,
  Dialog,
  DialogActions,
  DialogProps,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { baseURL, toBase64 } from "../utils/helper";

interface Props {
  open: boolean;
  onClosingOthersModal: () => void;
}
interface WorkflowResponse {
  status: string;
  status_code: string;
}
interface Toast {
  message: string;
  type: AlertColor;
}
interface WorkflowRequest {
  Name: string;
  Email_Adress: string;
  Employee_code: string;
  Issue_Type: string;
  copyingManager: string;
  Description: string;
  Subject: string;
  Attachment: any;
  fileName: string;
}
function OthersModal(props: Props) {
  const { onClosingOthersModal, open } = props;
  const [displayToast, setDisplayToast] = useState<Toast>({
    message: "",
    type: "info",
  });
  const { emp_id, emp_name, employee_email_id, manager_email_id } =
    JSON.parse(localStorage.getItem("user") as any) || {};
  const initialValue: WorkflowRequest = {
    Name: emp_name.toString(),
    Email_Adress: employee_email_id.toString(),
    Employee_code: emp_id.toString(),
    Issue_Type: "",
    copyingManager: manager_email_id.toString(),
    Description: "",
    Subject: "",
    Attachment: null,
    fileName: "",
  };

  const [loading, setLoading] = useState(false);
  const [formValue, setFormValue] = useState(initialValue);
  const issueTypes = [
    "Benefits",
    "Insurance",
    "Offboarding",
    "Onboarding",
    "Payroll",
    "Service Request",
    "Others",
  ];
  async function readAttachments() {
    try {
      if (formValue["Attachment"]) {
        const base64 = await toBase64(formValue["Attachment"]);
        return base64;
      }
    } catch (error) {
      console.log("error in reading file : ", error);
    }
    return "";
  }
  async function onSubmitForm() {
    setLoading(true);
    try {
      const base64 = await readAttachments();
      const tempFormValues = { ...formValue, Attachment: base64 };
      let requestJSON: any = {};
      let requestArray = [];
      requestArray.push(tempFormValues);
      requestJSON["Data"] = requestArray;
      const submitFormRequest = await fetch(`${baseURL}/fun/workflow`, {
        method: "POST",
        body: JSON.stringify(requestJSON),
      });
      const parsedResponse: WorkflowResponse = await submitFormRequest.json();
      console.log("parsed response : ", parsedResponse);
      if (parsedResponse?.status_code === "200") {
        console.log("came inside if : ", parsedResponse);
        setDisplayToast({
          message: `Your ticket has been created ${parsedResponse?.status}. you sit back and relax`,
          type: "success",
        });
      } else {
        setDisplayToast({
          message: `Error in creating the ticket. Please try again or contact IT Next!`,
          type: "error",
        });
      }
    } catch (error) {
      console.log("Error in sending request", error);
      setDisplayToast({
        message: `Error in creating the ticket. Please try again or contact IT Next!`,
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  }
  const handleClose: DialogProps["onClose"] = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    onClosingOthersModal();
  };
  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth="md">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "12px 24px 12px 24px",
          }}
        >
          <Typography variant="h5" style={{ flexGrow: 1 }}>
            Others
          </Typography>
          <IconButton onClick={onClosingOthersModal}>
            <Close />
          </IconButton>
        </div>
        <Grid container padding={3} spacing={5}>
          <Grid item xs={4}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="Name"
              variant="outlined"
              value={formValue["Name"]}
              onChange={(event) => {
                setFormValue((oldFormValue) => ({
                  ...oldFormValue,
                  Name: event.target.value,
                }));
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="Email Address"
              variant="outlined"
              type="email"
              value={formValue["Email_Adress"]}
              onChange={(event) => {
                setFormValue((oldFormValue) => ({
                  ...oldFormValue,
                  Email_Adress: event.target.value,
                }));
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="Employee Code"
              variant="outlined"
              type="text"
              value={formValue["Employee_code"]}
              onChange={(event) => {
                setFormValue((oldFormValue) => ({
                  ...oldFormValue,
                  Employee_code: event.target.value,
                }));
              }}
            />
          </Grid>
        </Grid>
        <Grid container padding={3} spacing={5}>
          <Grid item xs={4}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="Copying Manager"
              variant="outlined"
              value={formValue["copyingManager"]}
              onChange={(event) => {
                setFormValue((oldFormValue) => ({
                  ...oldFormValue,
                  copyingManager: event.target.value,
                }));
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="Subject"
              variant="outlined"
              value={formValue["Subject"]}
              onChange={(event) => {
                setFormValue((oldFormValue) => ({
                  ...oldFormValue,
                  Subject: event.target.value,
                }));
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="Description"
              variant="outlined"
              multiline
              rows={2}
              maxRows={4}
              value={formValue["Description"]}
              onChange={(event) => {
                setFormValue((oldFormValue) => ({
                  ...oldFormValue,
                  Description: event.target.value,
                }));
              }}
            />
          </Grid>
        </Grid>
        <Grid container padding={3} spacing={5}>
          <Grid item xs={4}>
            <InputLabel id="demo-simple-select-standard-label">
              Issue Type
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={formValue["Issue_Type"]}
              onChange={(event) => {
                setFormValue((oldFormValue) => ({
                  ...oldFormValue,
                  Issue_Type: event.target.value,
                }));
              }}
              fullWidth
            >
              {issueTypes.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item xs={4}>
            <InputLabel id="demo-simple-select-standard-label">
              Attachment
            </InputLabel>
            <input
              type="file"
              id="outlined-basic"
              onChange={(event) => {
                let files: any = event.target.files;
                setFormValue((oldFormValue) => ({
                  ...oldFormValue,
                  Attachment: files[0],
                  fileName: files[0].name,
                }));
              }}
            />
          </Grid>
        </Grid>
        <DialogActions>
          <Button
            style={{
              backgroundColor: "#1A202C",
              color: "white",
              textTransform: "none",
            }}
            variant="contained"
            onClick={onClosingOthersModal}
          >
            close
          </Button>
          <Button
            style={{
              backgroundColor: "#1A202C",
              color: "white",
              textTransform: "none",
            }}
            variant="contained"
            type="submit"
            disabled={loading}
            onClick={onSubmitForm}
          >
            submit
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={Object.values(displayToast)[0].length > 0}
        autoHideDuration={10000}
        onClose={() => {
          setDisplayToast({ message: "", type: "info" });
        }}
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
        key={"topright"}
      >
        <Alert
          onClose={() => {
            setDisplayToast({ message: "", type: "info" });
          }}
          severity={displayToast.type}
          sx={{ width: "100%" }}
        >
          {displayToast.message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default OthersModal;
